/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-12-10 14:31:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-20 17:28:32
 */
import React, {Component, Fragment} from 'react'
import moment from 'moment'
import './index.css'
import * as dateTimeTools from './dateTimeTools'
import {Form, Input, Button, Tabs, Table, Pagination, DatePicker, Radio, Badge, Space, Dropdown, Modal} from 'antd';
import Template from '../template';
import {
    getOrderDownload,
    getOrderProduction,
    getOrderProduction_text,
    getOrderUpload,
    getOrderData,
    downloadOrderBychild,
    getProductInspectionOrder,
    getTechnologyInspectionOrder,
    getSimulationData,
    getTechnicalInspectionOrderReExameOrder,
    getTechnicalInspectionOrderReSubmitOrder
} from './actions';
import {message} from 'antd'
import {transformtime} from '../../../../../utils/tools';
import OrderDetail from './OrderDetail'
import expandIcon from './img/icon-下拉.png'
import expandIcon_1 from './img/icon-下拉_1.png'
import {connect} from 'react-redux'
import {CreateWSToClient} from './createWSToClient';

class MyOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            type: 1,
            page: 1,
            total: 0,
            startTime: '',
            endTime: '',
            disabled: false,
            nowClickOrderId: 1,
            expandedRowKeys: [],
            tabIndex: '1',//存储当前tab页的key值
            currentUserId: '',//存储当前用户id
            isLoading: false,
            timeModeRadioValue: 4,

            openIsDownOrderListFlag: false,//点击主订单下载时，确认是否下载所有子订单数据
            nowReadyDLOrder: {downLoadOrderFilesList: []},
            wsToClientTimerFlag: true, //对客户端的ws通信进行重连处理
        }
        this.webSocketClient = null;
        this.wsTimer = null;
        this.refTable = {};
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //   // console.log(nextProps)
    //   debugger
    //   if (this.state.currentUserId !== nextProps.user.userId) {
    //     this.setState({
    //       currentUserId:nextProps.user.userId
    //     })
    //     return true
    //   }
    //   return false
    // }

    static getDerivedStateFromProps(nextProps, preState) {
        if (preState.currentUserId !== nextProps.user.userId) {
            return {
                currentUserId: nextProps.user.userId
            }
        }

        return null
    }

    componentDidMount() {
        // console.log(this.props.user.userId)
        // this.setState({
        //   currentUserId:this.props.user.userId
        // })
        // let tabIndex = window.history.tabIndex;
        // if (tabIndex !== undefined) {  //如果之后有需要，可以在这里进行细分以达到防止非法用户使用该功能
        //   this.onTabChange(tabIndex)
        // }
        // else {
        //   this.onTabChange('1')
        // }
        let index = this.props.location.state && this.props.location.state.index;
        if (index) {
            this.onTabChange(index)
        } else {
            this.onTabChange('1')
        }
    }

    //读取所有订单
    loadData = async (type, page, orderId = '') => {
        debugger
        const {startTime, endTime} = this.state;
        const {user} = this.props;
        let data = []
        // let userId = this.state.currentUserId
        // let userId = user.userId
        const {userId, token} = user;
        let res
        switch (type) {
            case "1":
                res = await getOrderDownload(page, 10, userId, orderId, startTime, endTime,token);
                break;
            case "2":
                res = await getOrderUpload(page, 10, userId, orderId, startTime, endTime);
                break;
            case "3":
                res = await getOrderData(page, 10, userId, orderId, startTime, endTime, this.props.user.name);
                break;
            case "4":
                res = await getOrderProduction_text(page, 10, userId, orderId, startTime, endTime, this.props.user.name);
                break;
            case "5":
                res = await getSimulationData(page, 10, userId, orderId, startTime, endTime);
                // res = await getOrderData(page, 10, userId, orderId, startTime, endTime);
                break;
            case "6":
                res = await getProductInspectionOrder(page, 10, userId, orderId, startTime, endTime);
                break;
            case "7":
                res = await getTechnologyInspectionOrder(page, 10, userId, orderId, startTime, endTime);
                break;
            default:
                break;
        }
        console.log("loadData", data, res, this.state.data);
        if (!res) {
            res = {records: [], total: 0}
            // message.error("订单查询失败！");
            // return;
            this.setState({
                isLoading: false
            })
        }
        // console.log(res)
        if (type === '3') {
            {
                data = (res && res.rows) || []
                data.forEach((element, index) => {
                    element.key = element.orderId
                    element.index = index
                });
                // console.log(data)
                this.setState({type: type, data, total: res.total, page: page, isLoading: false})
            }
        } else if (type === '7' || type === '5') {
            {
                data = (res && res.data) || []
                data.forEach((element, index) => {
                    element.key = element.orderId
                    element.index = index
                });
                // console.log(data)
                this.setState({type: type, data, total: res.total, page: page, isLoading: false})
            }
        } else if (type !== '6') {
            data = (res && res.records) || []
            console.log('setData', data);
            data.forEach((element, index) => {
                element.key = element.orderId
                element.index = index
            });
            // console.log(data)
            this.setState({type: type, data, total: res.total, page: page, isLoading: false})
        } else {
            setTimeout(() => {
                data = (res && res.data) || []
                console.log('setData', data);
                if (data.length === 0) {
                    this.setState({
                        type: type,
                        data: [],
                        pageNum: 1,
                        total: 0,
                        isLoading: false

                    })
                } else {
                    data.list.forEach((element, index) => {
                        element.key = element.id
                    })
                    this.setState({
                        type: type,
                        data: data.list,
                        total: data.total,
                        page: data.pageNum,
                        isLoading: false

                    })
                }
            }, 100);
        }
    }
    onPageChange = (page) => {
        let type = this.state.type
        this.refTable && this.refTable.resetFields && this.refTable.resetFields();
        console.log("onPageChange----this.refTable", this.refTable);
        this.loadData(type, page)
    }
    onTabChange = async (key) => {
        this.refs.searchInput.input.value = ''
        this.refTable && this.refTable.resetFields && this.refTable.resetFields();
        console.log("onTabChange----this.refTable", this.refTable);
        this.setState({
            data: [],
            isLoading: true,
            tabIndex: key
        }, () => {
            this.loadData(key, 1);
        })
    }


    handleChange = (event, key) => {
        // this.handleRadioclick(0);
        switch (key) {
            case 1:
                if (event !== null) {
                    this.setState({
                        startTime: moment(event),
                    })
                    if (moment(event) > this.state.endTime || this.state.endTime === "") {
                        this.setState({
                            endTime: moment(event),
                        })
                    }
                } else {
                    this.setState({
                        startTime: '',
                        endTime: '',
                    }, () => {
                        if (this.state.startTime === '' && this.state.endTime === '') {
                            this.setState({
                                // disabled: false
                            })
                        }
                    })
                }
                break;
            case 2:
                if (event !== null) {
                    this.setState({
                        // endTime: transformtime(event._d, "yyyy-mm-dd"),
                        endTime: moment(event),
                        // disabled: true
                    })
                    if (this.state.startTime > moment(event) || this.state.startTime === "") {
                        this.setState({
                            startTime: moment(event),
                        })
                    }
                } else {
                    this.setState({
                        startTime: '',
                        endTime: '',
                    }, () => {
                        if (this.state.startTime === '' && this.state.endTime === '') {
                            this.setState({
                                // disabled: false
                            })
                        }
                    })
                }
                break;
            default:
                break;
        }
        this.searchOrder();
    }

    //获取Radiovalue
    handleRadioclick = (num) => {
        // console.log(event.target)
        // debugger
        if (num === 1) { //今天
            let time = dateTimeTools.returnToday();
            // console.log("handleRadioclick", time);
            this.setState({startTime: time.startTime, endTime: time.endTime});
        } else if (num === 2) {  //一周
            let time = dateTimeTools.returnNowOneWeek();
            this.setState({startTime: time.startTime, endTime: time.endTime});
        } else if (num === 3) {  //一月内
            let time = dateTimeTools.returnNowOneMonth();
            this.setState({startTime: time.startTime, endTime: time.endTime});
        } else if (num === 4) {  //全部
            // let time = dateTimeTools.returnNowOneMonth();
            this.setState({startTime: '', endTime: ''});
        }
        this.setState({timeModeRadioValue: num}, () => {
            this.searchOrder();
        })
    }

    showAndCloseOrderChildren(flag, data) {
        console.log('showAndCloseOrderChildren', flag, data, data.index * 1, data.key * 1);
        if (flag) {
            // console.log('showAndCloseOrderChildren', data);
            this.setState({
                nowClickOrderId: data.index * 1,
                expandedRowKeys: [data.key],
            })
        } else {
            this.setState({expandedRowKeys: []});
        }
    }

    closeElseRows(expandedRows) {
        // console.log("expandedRows", expandedRows);
        // this.setState({expandedRowKeys:[]});
    }

    statusReturnColor(type) {
        switch (type) {
            case "进行中":
                return "rgba(0,114,229,1)";
            case "已完成":
                return "rgba(15,233,0,1)";
            case "已截止":
                return "rgba(238,96,96,1)";
            default:
                break;
        }
    }

    statusReturnChildrenColor(type) {
        switch (type) {
            case "待处理":
                return "rgba(255,146,16,1)";
            case "处理中":
                return "rgba(0,114,229,1)";
            case "已完成":
                return "rgba(15,233,0,1)";
            case "推送失败":
                return "rgba(238,96,96,1)";
            default:
                break;
        }
    }

    /* 主订单三个按钮事件 */
    finishIsSending(key) {  //终止传输
        let data = this.state.data;
        // let nowChilrenId = this.state.nowClickOrderId;
        let nowChilrenId = key - 1;
        let childrenData = data[nowChilrenId];
        childrenData.isSending = false;
        data[nowChilrenId] = childrenData;
        // console.log('finishIsSending', data,nowChilrenId,childrenData);
        this.setState({data: data});
    }

    finishOrder(key) {  //结束任务
        let data = this.state.data;
        let nowChilrenId = key - 1;
        let childrenData = data[nowChilrenId];
        childrenData.isSending = false;
        childrenData.orderStatus = "已截止";
        data[nowChilrenId] = childrenData;
        this.setState({data: data});
    }

    overOrder(key) {  //完成任务
        let data = this.state.data;
        let nowChilrenId = key - 1;
        let childrenData = data[nowChilrenId];
        childrenData.isSending = false;
        childrenData.orderStatus = "已完成";
        data[nowChilrenId] = childrenData;
        this.setState({data: data});
    }

    tabelSwitchOperation(data) {
        //,background:"rgba(0,114,229,1)", color:"rgba(255,255,255,1)"
        switch (data.orderStatus) {
            case "进行中":
                let childrenFinishCount = data.childrenFinishCount;
                let childrenConductCount = data.childrenConductCount;
                if (childrenFinishCount * 1 == 0 && childrenConductCount * 1 == 0)
                    return <Button className="order_operation_over"
                                   onClick={() => this.finishOrder(data.key)}>结束任务</Button>
                else if (childrenFinishCount * 1 > 0 && childrenConductCount * 1 == 0)
                    return <Button className="order_operation_finish"
                                   onClick={() => this.overOrder(data.key)}>完成任务</Button>
                else if (childrenConductCount * 1 > 0 && data.isSending)
                    return <Button className="order_operation_conduct"
                                   onClick={() => this.finishIsSending(data.key)}>终止传输</Button>
            default:
                return <Button className="order_hideButton" disabled>终止传输</Button>   //作为样式对其，所以让上面不break也会进来
        }
    }

    /*---------------*/

    /* 子订单按钮事件（推送生产、拒绝、清除（详情、下载订单两个按钮事件暂无）） */
    sendOrder(childrenIndex) {  //推送生产
        let data = this.state.data;
        let nowChilrenId = this.state.nowClickOrderId;
        let childrenData = data[nowChilrenId];
        childrenData.childrenUntreatedCount -= 1;
        childrenData.childrenConductCount += 1;
        childrenData.orderStatus = "进行中";
        let temp = [];
        childrenData.orderChildren.map((order, index) => {
            if (index != childrenIndex)
                temp.push(order);
            else {
                order.status = "处理中";
                temp.push(order);
            }
        })
        childrenData.orderChildren = temp;
        data[nowChilrenId] = childrenData;
        this.setState({data: data});
    }

    rejectOrder(childrenIndex) {  //拒绝
        let data = this.state.data;
        let nowChilrenId = this.state.nowClickOrderId;
        let childrenData = data[nowChilrenId];
        childrenData.childrenUntreatedCount -= 1;
        childrenData.childrenAllCount -= 1;
        let temp = [];
        childrenData.orderChildren.map((order, index) => {
            if (index != childrenIndex)
                temp.push(order);
        })
        childrenData.orderChildren = temp;
        data[nowChilrenId] = childrenData;
        this.setState({data: data});
    }

    removeOrder(childrenIndex) {  //清除(基本逻辑等于拒绝，但数据操作略有不同---childrenFailCount)
        let data = this.state.data;
        let nowChilrenId = this.state.nowClickOrderId;
        let childrenData = data[nowChilrenId];
        childrenData.childrenFailCount -= 1;
        childrenData.childrenAllCount -= 1;
        let temp = [];
        childrenData.orderChildren.map((order, index) => {
            if (index != childrenIndex)
                temp.push(order);
        })
        childrenData.orderChildren = temp;
        data[nowChilrenId] = childrenData;
        this.setState({data: data});
    }

    returnChildrenButtons(orderStatus, childrenStatus, childrenIndex, isSending) {
        let plugin;
        switch (orderStatus) {
            case "进行中":
                switch (childrenStatus) {
                    case "待处理":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button className="order_children_table_content_column_buttons_manager_send"
                                    onClick={() => this.sendOrder(childrenIndex)}
                                    title={!isSending ? "订单已完成，未处理子订单将在三天内清除" : null}>
                                {!isSending ? <div
                                    className="order_children_table_content_column_buttons_manager_send_img">!</div> : null}
                                推送生产
                            </Button>
                            <Button className="order_children_table_content_column_buttons_manager_reject"
                                    onClick={() => this.rejectOrder(childrenIndex)}>拒绝</Button>
                        </Fragment>;
                        break;
                    case "处理中":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button className="order_children_table_content_column_buttons_manager_sending"
                                    disabled>下载订单</Button>
                            <Button className="order_children_hideButton" disabled>拒绝</Button>
                        </Fragment>;
                        break;
                    case "已完成":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button
                                className="order_children_table_content_column_buttons_manager_send">下载订单</Button>
                            <Button className="order_children_hideButton" disabled>拒绝</Button>
                        </Fragment>;
                        break;
                    case "推送失败":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button className="order_children_table_content_column_buttons_manager_reject"
                                    onClick={() => this.removeOrder(childrenIndex)}>清除</Button>
                            <Button className="order_children_hideButton" disabled>拒绝拒绝</Button>
                        </Fragment>;
                        break;
                    default:
                        plugin = null;
                        break;
                }
                return plugin;
            case "已完成":
                switch (childrenStatus) {
                    case "待处理":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button className="order_children_table_content_column_buttons_manager_send"
                                    onClick={() => this.sendOrder(childrenIndex)}
                                    title="订单已完成，未处理子订单将在三天内清除">
                                <div className="order_children_table_content_column_buttons_manager_send_img">!</div>
                                推送生产
                            </Button>
                            <Button className="order_children_table_content_column_buttons_manager_reject">拒绝</Button>
                        </Fragment>;
                        break;
                    case "处理中":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button className="order_children_table_content_column_buttons_manager_sending"
                                    disabled>下载订单</Button>
                            <Button className="order_children_hideButton" disabled>拒绝</Button>
                        </Fragment>;
                        break;
                    case "已完成":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button
                                className="order_children_table_content_column_buttons_manager_send">下载订单</Button>
                            <Button className="order_children_hideButton" disabled>拒绝</Button>
                        </Fragment>;
                        break;
                    case "推送失败":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button className="order_children_table_content_column_buttons_manager_reject"
                                    disabled>清除</Button>
                            <Button className="order_children_hideButton" disabled>拒绝拒绝</Button>
                        </Fragment>;
                        break;
                    default:
                        plugin = null;
                        break;
                }
                return plugin;
            case "已截止":
                switch (childrenStatus) {
                    case "待处理":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button className="order_children_table_content_column_buttons_manager_sending"
                                    title="订单已截止，如需再次推送该条数据，请重新请求订单" disabled>推送生产</Button>
                            <Button className="order_children_table_content_column_buttons_manager_sending"
                                    title="订单已截止，如需再次推送该条数据，请重新请求订单" disabled>拒绝</Button>
                        </Fragment>;
                        break;
                    case "推送失败":
                        plugin = <Fragment>
                            <Button
                                className="order_children_table_content_column_buttons_manager_detailed">详情</Button>
                            <Button className="order_children_table_content_column_buttons_manager_sending"
                                    title="订单已截止，如需再次推送该条数据，请重新请求订单" disabled>清除</Button>
                            <Button className="order_children_hideButton" disabled>推送生产</Button>
                        </Fragment>;
                        break;
                    default:
                        plugin = null;
                        break;
                }
                return plugin;
            default:
                break;
        }
    }

    searchOrder = () => {
        let input = this.refs.searchInput.input
        // console.log(input.state.value)
        this.loadData(this.state.type, 1, input.value)
    }

    //2023.05.10 这里之后需要做几件事
    //   （1）检测当前电脑是否已安装客户端。half
    // （2）未安装跳下载链接，让客户安装。
    // （3）如果安装，检测客户端，想办法让它以当前用户启动。
    // （4）如已启动，将之前点击下载的订单（一个订单或一个订单列表），一同在下载中下载（或者分开，必须在已启动状态下点击下载，才会将链接交互至客户端让其下载。）
    //1、打开客户端
    openClient = (data) => {
        //通过这个循环保证修改每个订单的下载状态
        // console.log('openClient',data)
        let flag = true;
        data.map((item) => {
            this.downloadOrder(item);
            if (!item.orderDownloadAddr && !item.dataURL) flag = false
        })
        if (!flag) {
            message.error("下载订单内含有没有文件地址的订单，请确认订单完成后重试！");
            return;
        }
        // return;
        let _this = this;
        const linkTmp = document.createElement('a');
        linkTmp.href = 'ydspacebasedbee://';
        linkTmp.onclick = function (e) {
            _this.callapp_openClient({
                data: data,
                callbackTrue: function (dataT) {
                    message.success("准备打开客户端，正在预备下载！");
                    _this.createWSForSimple(data);
                },
                callbackFlase: function () {
                    message.info("检测到本机未安装客户端，请先安装客户端后再下载订单！");
                    console.log("客户端打开失败！");
                }
            });
        }
        linkTmp.click();
    }

    //确认客户端是否被打开的回调函数（感觉有点离谱，但是暂时确实想不到更好的办法，好像百度网盘也是类似的逻辑）
    callapp_openClient({data, callbackTrue, callbackFlase}) {
        var t = setTimeout(callbackFlase, 1000);
        var inp = document.createElement("input");
        inp.style.position = "absolute";
        inp.style.clip = "rect(0, 0, 0, 0)";
        // 出现下载框的时候往下跳的问题
        inp.style.top = '0'
        inp.style.left = '0'

        // inp.style.display="none";
        function blur() {
            window.clearTimeout(t);
            callbackTrue(data);
        }

        inp.addEventListener("blur", blur); // 监听blur事件
        document.body.appendChild(inp);
        inp.focus(); // 获取焦点
        setTimeout(function () { // 删除无用的标签
            inp.removeEventListener("blur", blur);
            document.body.removeChild(inp);
        }, 1000);
        //有客户端 如果有本地exe应用，就会弹框，input失去焦点，然后执行blur()事件 清空t定时器 - 删除无用的标签定时器
        //无客户端 不会弹框，input也不会失去焦点 触发t定时器- 执行callback - 删除无用的标签定时器
    }

    /* 网站简单的ws */
    //创建简单的ws通讯
    createWSForSimple = (data) => {
        let _this = this;
        this.webSocketClient = new WebSocket('ws://127.0.0.1:9312');// 新建一个WebSocket通信，连接一个本地服务器
        this.webSocketClient.onopen = function (e) {             //连接建立时触发函数
            console.log('网站ws通讯已创建，目前状态为：' + _this.webSocketClient.readyState);
            clearInterval(_this.wsTimer);
            _this.setState({wsToClientTimerFlag: true});
            if (_this.webSocketClient.readyState === 1) {
                _this.wsSendMessage(JSON.stringify({
                    type: 'transferToken',
                    data: {token: _this.props.user.token, username: _this.props.user.username}
                }));
                _this.wsSendMessage(JSON.stringify({type: 'download', data: data}));       //传送消息
            }
        }
        this.webSocketClient.onmessage = function (evt) {       //客户端接收服务端数据时触发
            console.log("网站接收到了来自客户端的消息：", evt);//向页面追加显示服务端发送给客户端的消息
        }
        this.webSocketClient.onclose = function (evt) {          //连接关闭时触发
            console.log("网站的连接通关已关闭!", evt);
            if (_this.state.wsToClientTimerFlag) {
                let nowTimer = 0;
                let timeCount = 500;
                let maxTimer = 15000;
                _this.wsTimer = setInterval(() => {
                    _this.createWSForSimple(data);
                    nowTimer += timeCount;
                    console.log("网站尝试连接客户端中，重试：", nowTimer / timeCount);
                    if (nowTimer >= maxTimer) {
                        clearInterval(_this.wsTimer);
                        console.log("网站尝试连接客户端重试结束……");
                    }
                }, timeCount);
                _this.setState({wsToClientTimerFlag: false});
            }
        };

    }
    wsSendMessage = (mes) => {   //向服务端发送消息
        console.log("wsSendMessage", mes);
        this.webSocketClient.send(mes);       //传送消息
    }
    wsExit = () => {
        this.webSocketClient.close();                             //关闭ws通信
    }
    /* ----------------------- */

    //2、获取下载链接的主函数
    downloadOrder = async (order) => {
        try {
            // console.log("order", order);
            let orderUrl
            switch (this.state.type) {
                case '1':
                    // orderUrl = await downloadOrder(order.orderId)

                    orderUrl = await downloadOrderBychild(order.id)
                    break;
                case '3':
                    if (order.orderStatus === '数据归档成功') {
                        if (this.isURL(order.dataURL)) {
                            orderUrl = order.dataURL
                        } else {
                            orderUrl = `http://${global.ip}:8888` + order.dataURL
                        }
                    } else {
                        orderUrl = ''
                    }
                    break;
                default:
                    break;
            }
            // console.log("orderUrl",orderUrl,order.rawDataPath);
            if (orderUrl === '') {
                message.error('订单未完成或订单无法下载')
            } else {
                //2023.05.16 因要把下载动作放到客户端上，复制下载url的动作就禁止掉（并且现在会进行列表下载）
                // if (navigator.clipboard && window.isSecureContext) {
                //   // navigator clipboard 向剪贴板写文本
                //   message.success('订单下载url已复制')
                //   navigator.clipboard.writeText(orderUrl)
                // } else {
                //   // 创建text area
                //   const textArea = document.createElement('textarea')
                //   textArea.value = orderUrl
                //   // 使text area不在viewport，同时设置不可见
                //   document.body.appendChild(textArea)
                //   textArea.focus()
                //   textArea.select()
                //   message.success('订单下载url已复制')
                //   document.execCommand('copy')
                //   textArea.remove()
                // }
            }
            this.loadData(this.state.type, 1)
        } catch (error) {

        }
    }
    isURL = (str) => {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return pattern.test(str);
    }

    returnOrderStatus = (status) => {
        if (status === "assigned") {
            return "处理中";
        } else if (status === "created") {
            return "待处理";
        } else if (status === "finished") {
            return "已完成";
        } else {
            return "未知状态";
        }
    }

    //技术检验订单重新检验
    reExameOrder = async (orderDetail) => {
        let res = await getTechnicalInspectionOrderReExameOrder(orderDetail.ordercode);
        if (res.code === 0) message.success("重新检验请求成功！");
        else message.error("重新检验请求失败！");
    }
    //技术检验订单重新提交
    reSubmitOrder = async (orderDetail) => {
        let res = await getTechnicalInspectionOrderReSubmitOrder(orderDetail.ordercode);
        if (res.code === 0) message.success("重新提交请求成功！");
        else message.error("重新提交请求失败！");
    }

    /*---------------*/

    render() {
        const expandedRowRender = () => {
            // console.log('this.state.tabIndex',this.state.tabIndex);
            // if (this.state.tabIndex !== '4')
            // return null;
            let datas = this.state.data[this.state.nowClickOrderId];

            if (datas.orderChildren)
                return (
                    <div className="order_children_window" key={`${datas.orderId}-${this.state.type}`}>
                        <div className="order_children_title">
                            <div className="order_children_title_name">{datas.orderId}</div>
                            <div className="order_children_title_count">
                                <div className="order_children_title_countNum">
                                    <div
                                        className="order_children_title_countNum_num">{datas.childrenUntreatedCount}</div>
                                    条待处理
                                </div>
                                <div className="order_children_title_countNum">
                                    <div className="order_children_title_countNum_num">{datas.childrenFinishCount}</div>
                                    条已完成
                                </div>
                                <div className="order_children_title_countNum">
                                    <div
                                        className="order_children_title_countNum_num">{datas.childrenConductCount}</div>
                                    条处理中
                                </div>
                                <div className="order_children_title_countNum">
                                    <div className="order_children_title_countNum_num">{datas.childrenFailCount}</div>
                                    推送失败
                                </div>
                            </div>
                        </div>
                        <div className="order_children_table">
                            <div className="order_children_table_header">
                                <div className="order_children_table_header_num"></div>
                                <div className="order_children_table_header_username">子订单名称</div>
                                <div className="order_children_table_header_order_children">数据状态</div>
                                <div className="order_children_table_header_points">数据到达时间</div>
                                <div className="order_children_table_header_buttons">操作</div>
                            </div>
                            <div className="order_children_table_content">
                                {datas.orderChildren.map((data, index) => {
                                    return (
                                        <div className="order_children_table_content_column"
                                             key={index + "-" + this.state.nowClickOrderId}>
                                            <div className="order_children_table_content_column_num">{index + 1}</div>
                                            <div className="order_children_table_content_column_username">
                                                {data.name}
                                            </div>
                                            <div className="order_children_table_content_column_points"
                                                 style={{color: this.statusReturnChildrenColor(data.status)}}>
                                                <div className="order_status_point"
                                                     style={{background: this.statusReturnChildrenColor(data.status)}}/>
                                                {data.status}
                                            </div>
                                            <div className="order_children_table_content_column_order_children">
                                                {data.sendTime.replace("T", " ")}
                                                <div
                                                    className="order_children_table_content_column_order_children_all"></div>
                                            </div>
                                            <div className="order_children_table_content_column_buttons">
                                                <div className="order_children_table_content_column_buttons_manager">
                                                    {this.returnChildrenButtons(datas.orderStatus, data.status, index, datas.isSending)}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                )
        };

        const expandedRowRenderForProduceOrder = () => {
            // console.log('this.state.tabIndex',this.state.tabIndex);
            // if (this.state.tabIndex !== '4')
            // return null;
            let datas = this.state.data[this.state.nowClickOrderId];
            if (datas.proOrderList) {
                return (
                    <div className="order_children_window" key={`${datas.orderId}-${this.state.type}`}>
                        <div className="order_children_title">
                            <div className="order_children_title_name">{datas.orderId}</div>
                        </div>
                        <div className="order_children_table">
                            <div className="order_children_table_header">
                                <div className="order_children_table_header_num"></div>
                                <div className="order_children_table_header_username">子订单号</div>
                                <div className="order_children_table_header_points">订单状态</div>
                                <div className="order_children_table_header_username">驱动模式</div>
                                <div className="order_children_table_header_buttons">操作</div>
                            </div>
                            <div className="order_children_table_content">
                                {datas.proOrderList.map((data, index) => {
                                    // console.log('orderChildren',data,data.status);
                                    return (
                                        <div className="order_children_table_content_column"
                                             key={index + "-" + this.state.nowClickOrderId}>
                                            <div className="order_children_table_content_column_num">{index + 1}</div>
                                            <div className="order_children_table_content_column_username1"
                                                 title={data.fileName}>
                                                {data.proOrderId}
                                            </div>
                                            <div className="order_children_table_content_column_points"
                                                 style={{color: this.statusReturnChildrenColor(data.status)}}>
                                                <div className="order_status_point"
                                                     style={{background: this.statusReturnChildrenColor(data.status)}}/>
                                                {data.orderStatus}
                                            </div>
                                            <div className="order_children_table_content_column_username">
                                                {data.orderDriveType}
                                            </div>
                                            <div className="order_children_table_content_column_buttons">
                                                <div className="order_children_table_content_column_buttons_manager">
                                                    <Button className='order-operation-btn1'
                                                            onClick={() => this.OrderDetailOnRef.show(data, 21)}>详情</Button>
                                                    <Button className='order-operation-btn2'
                                                            onClick={() => this.openClient([data])}>下载</Button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                )
            }
        };

        const expandedRowRenderForDownloadOrder = () => {
            // console.log('this.state.tabIndex',this.state.tabIndex);
            // if (this.state.tabIndex !== '4')
            // return null;
            let datas = this.state.data[this.state.nowClickOrderId];
            if (datas.downLoadOrderFilesList) {
                let downloadCount = 0;
                let noDownloadCount = 0;
                datas.downLoadOrderFilesList.map((order) => {
                    if (order.downloadStatus === "已下载") downloadCount += 1;
                    else noDownloadCount += 1;
                })
                return (
                    <div className="order_children_window" key={`${datas.orderId}-${this.state.type}`}>
                        <div className="order_children_title">
                            <div className="order_children_title_name">{datas.orderId}</div>
                            <div className="order_children_title_count">
                                <div className="order_children_title_countNum">
                                    <div className="order_children_title_countNum_num">{noDownloadCount}</div>
                                    条未下载
                                </div>
                                <div className="order_children_title_countNum">
                                    <div className="order_children_title_countNum_num">{downloadCount}</div>
                                    条已下载
                                </div>
                                {/* <div className="order_children_title_countNum"><div className="order_children_title_countNum_num">{datas.childrenConductCount}</div>条处理中</div>
                <div className="order_children_title_countNum"><div className="order_children_title_countNum_num">{datas.childrenFailCount}</div>推送失败</div> */}
                            </div>
                        </div>
                        <div className="order_children_table">
                            <div className="order_children_table_header">
                                <div className="order_children_table_header_num"></div>
                                <div className="order_children_table_header_username">文件名称</div>
                                <div className="order_children_table_header_points">订单状态</div>
                                <div className="order_children_table_header_username">数据类型</div>
                                <div className="order_children_table_header_username">数据大小</div>
                                {/* <div className="order_children_table_header_order_children">数据类型</div> */}
                                {/* <div className="order_children_table_header_points">订单时间</div> */}
                                <div className="order_children_table_header_buttons">操作</div>
                            </div>
                            <div className="order_children_table_content">
                                {datas.downLoadOrderFilesList.map((data, index) => {
                                    // console.log('orderChildren',data,data.status);
                                    return (
                                        <div className="order_children_table_content_column"
                                             key={index + "-" + this.state.nowClickOrderId}>
                                            <div className="order_children_table_content_column_num">{index + 1}</div>
                                            <div className="order_children_table_content_column_username1"
                                                 title={data.fileName}>
                                                {data.fileName}
                                            </div>
                                            <div className="order_children_table_content_column_points"
                                                 style={{color: this.statusReturnChildrenColor(data.status)}}>
                                                <div className="order_status_point"
                                                     style={{background: this.statusReturnChildrenColor(data.status)}}/>
                                                {data.downloadStatus}
                                            </div>
                                            <div className="order_children_table_content_column_username">
                                                {data.resourceType}
                                            </div>
                                            <div className="order_children_table_content_column_username">
                                                {data.fileSize ? this.returnFileSizeText(data.fileSize) : "暂无"}
                                            </div>
                                            {/* <div className="order_children_table_content_column_order_children">
                        {data.orderCreationTime.replace("T", " ")}
                        <div className="order_children_table_content_column_order_children_all"></div>
                      </div> */}
                                            <div className="order_children_table_content_column_buttons">
                                                <div className="order_children_table_content_column_buttons_manager">
                                                    <Button className='order-operation-btn1'
                                                            onClick={() => this.OrderDetailOnRef.show(data, 1)}>详情</Button>
                                                    <Button className='order-operation-btn2'
                                                            onClick={() => this.openClient([data])}>下载</Button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                )
            }
        };
        const columns = {
            1: [
                {
                    title: '订单号',
                    dataIndex: 'orderId',
                    key: (resourceType, data, index) => {
                        return 'orderId' + `-${this.state.type}-${this.state.page}-${index}`
                    },
                    // 'orderId' + `-${this.state.type}-${this.state.page}`,
                    width: 300,
                },
                {
                    title: '数据类型',
                    dataIndex: 'resourceType',
                    key: 'resourceType',
                    render: (resourceType, data) => {
                        return <span>{resourceType ? resourceType : "暂无"}</span>
                    }
                }, {
                    title: '订单时间',
                    dataIndex: 'orderCreationTime',
                    key: 'orderCreationTime',
                    render: (orderCreationTime, data) => {
                        return <span>{transformtime(orderCreationTime, 'yyyy-mm-dd hh:mm:ss')}</span>
                    }
                }, {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (_, order) => {
                        return <div>
                            <Button className='order-operation-btn1'
                                    onClick={() => this.OrderDetailOnRef.show(order, 0)}>详情</Button>
                            {/* <Button className='order-operation-btn2' onClick={() => this.openClient(order.downLoadOrderFilesList)}>下载</Button> */}
                            <Button className='order-operation-btn2' onClick={() => this.setState({
                                openIsDownOrderListFlag: true,
                                nowReadyDLOrder: order
                            })}>下载</Button>
                        </div>
                    }
                },
            ],
            2: [
                {
                    title: '订单号',
                    dataIndex: 'orderId',
                    key: 'orderId' + `-${this.state.type}-${this.state.page}`,
                },
                {
                    title: '订单状态',
                    dataIndex: 'orderStatus',
                    key: 'orderStatus',
                },
                {
                    title: '数据类型',
                    dataIndex: 'resourceType',
                    key: 'resourceType',
                }, {
                    title: '订单时间',
                    dataIndex: 'orderCreationTime',
                    key: 'orderCreationTime',
                    render: (orderCreationTime, data) => {
                        return <span>{transformtime(orderCreationTime, 'yyyy-mm-dd hh:mm:ss')}</span>
                    }
                }, {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (_, order) => {
                        return <div>
                            <Button className='order-operation-btn1'
                                    onClick={() => this.OrderDetailOnRef.show(order, 20)}>详情</Button>
                        </div>
                    }
                },
            ],
            3: [
                {
                    title: '订单号',
                    dataIndex: 'parentOrderID',
                    key: (resourceType, data, index) => {
                        return 'orderId' + `-${this.state.type}-${this.state.page}-${index}`
                    },
                    // 'orderId' + `-${this.state.type}-${this.state.page}`,
                    width: 300,
                },
                {
                    title: '数据来源',
                    dataIndex: 'orderSource',
                    key: 'resourceType',
                    render: (resourceType, data) => {
                        return <span>{resourceType ? resourceType : "暂无"}</span>
                    }
                }, {
                    title: '订单时间',
                    dataIndex: 'submitDate',
                    key: 'orderCreationTime',
                    render: (submitDate, data) => {
                        return <span>{transformtime(submitDate, 'yyyy-mm-dd hh:mm:ss')}</span>
                    }
                }, {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (_, order) => {
                        return <div>
                            <Button className='order-operation-btn1'
                                    onClick={() => this.OrderDetailOnRef.show(order, 2)}>详情</Button>
                            {/* <Button className='order-operation-btn2' onClick={() => this.openClient(order.downLoadOrderFilesList)}>下载</Button> */}
                            <Button className='order-operation-btn2' onClick={() => this.setState({
                                openIsDownOrderListFlag: true,
                                nowReadyDLOrder: order
                            })}>下载</Button>
                        </div>
                    }
                },
            ],
            4: [
                {
                    title: '订单名称',
                    dataIndex: 'orderId',
                    key: 'orderId' + `-${this.state.type}-${this.state.page}`,
                    width: 120,
                    render: (orderId, datas) => (
                        <Fragment>
                            <div className="order_name">
                                {/* <img className="order_name_button" onClick={() => this.showAndCloseOrderChildren(orderId)} src={this.state.nowClickOrderId == orderId ? "images/userCenter/icon-下拉.png" : "images/userCenter/icon-下拉_1.png"} /> */}
                                <div className="order_name_id">{orderId}</div>
                            </div>
                        </Fragment>
                    )
                },
                {
                    title: '订单状态',
                    dataIndex: 'orderStatus',
                    key: 'orderStatus',
                    width: 120,
                    render: (orderStatus, data) => (
                        <div className="order_status">
                            <div className="order_status_point"
                                 style={{background: this.statusReturnColor(data.orderStatus)}}/>
                            <div className="order_status_name"
                                 style={{color: this.statusReturnColor(data.orderStatus)}}>{orderStatus}</div>
                        </div>
                    )
                },
                {
                    title: '开始时间-结束时间',
                    dataIndex: 'startAndEndTime',
                    key: 'startAndEndTime',
                    width: 225,
                    render: (startAndEndTime, data) => (
                        <div className="order_startAndEndTime">
                            <div className="order_startAndEndTime_start">{startAndEndTime.split(" - ")[0]}</div>
                            <div>{" - "}</div>
                            {/* 下面这个样式虽然不统一，但是还蛮怪好看的 */}
                            {/* <div className="order_startAndEndTime_end" style={{ color: data.orderStatus == "已截止" || data.isSending == false ? this.statusReturnColor(data.orderStatus) : null }}>{startAndEndTime.split(" - ")[1]}</div> */}
                            <div className="order_startAndEndTime_end"
                                 style={{color: data.orderStatus == "已截止" || data.isSending == false ? "rgba(238,96,96,1)" : null}}>{startAndEndTime.split(" - ")[1]}</div>
                        </div>
                    )
                },
                {
                    title: '订单时间',
                    dataIndex: 'startTime',
                    key: 'startTime',
                    width: 127,
                },
                {
                    title: '子订单',
                    dataIndex: 'childrenRecordCount',
                    key: 'childrenRecordCount',
                    width: 113,
                    render: (childrenRecordCount, data) => {
                        return (
                            <div className="order_children_out">
                                <div className="order_children">
                                    {/* {childrenRecordCount} */}
                                    {"( "}
                                    <div className="order_children_finish">{data.childrenFinishCount}</div>
                                    {" + "}
                                    <div className="order_children_conduct">{data.childrenConductCount}</div>
                                    {" )/"}
                                    <div className="order_children_all">{data.childrenAllCount}</div>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (operation, data) => {
                        return (
                            <div className="order_operation">
                                {/* <Button className='order-operation-btn1'>详情</Button> */}
                                <Button className="order_operation_detailed"
                                        onClick={() => this.OrderDetailOnRef.show(data, 4)}>详情</Button>
                                {this.tabelSwitchOperation(data)}
                            </div>
                        )
                    }
                },
            ],
            5: [
                {
                    title: '订单号',
                    dataIndex: 'orderId',
                    key: 'orderId' + `-${this.state.type}-${this.state.page}`,
                    render: (_, data) => {
                        return <span title={data.simulationrequirementid}>{data.simulationrequirementid}</span>
                    }
                },
                {
                    title: '订单状态',
                    dataIndex: 'orderStatus',
                    key: 'orderStatus',
                    render: (_, data) => {
                        return <span title={data.completecondition}>{data.completecondition}</span>
                    }
                },
                {
                    title: '原数据名称',
                    dataIndex: 'rawDataName',
                    key: 'rawDataName',
                    render: (_, data) => {
                        return <span title={data.requirementname}>{this.returnLessName(data.requirementname)}</span>
                    }
                },
                {
                    title: '订单时间',
                    dataIndex: 'orderCreationTime',
                    key: 'orderCreationTime',
                    render: (orderCreationTime, data) => {
                        return <span>{transformtime(data.starttime, 'yyyy-mm-dd hh:mm:ss')}</span>
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (_, order) => {
                        return <div>
                            <Button className='order-operation-btn1'
                                    onClick={() => this.OrderDetailOnRef.show(order, 5)}>详情</Button>
                            {/* <Button className='order-operation-btn2'>下载</Button> */}
                        </div>
                    }
                },
            ],
            6: [
                {
                    title: '订单号',
                    dataIndex: 'orderId',
                    key: 'orderId' + `-${this.state.type}-${this.state.page}`,
                    width: 300,
                    render: (_, data) => {
                        return <span title={data.orderCode}>{data.orderCode}</span>
                    }
                },
                {
                    title: '订单状态',
                    dataIndex: 'orderStatus',
                    key: 'orderStatus',
                },
                {
                    title: '产品名称',
                    dataIndex: 'productSubclassName',
                    key: 'productSubclassName',
                },
                {
                    title: '订单时间',
                    dataIndex: 'orderCreationTime',
                    key: 'orderCreationTime',
                    render: (_, data) => {
                        return <span>{transformtime(data.createDate, 'yyyy-mm-dd hh:mm:ss')}</span>
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (_, orderDetail) => {
                        console.log("orderDetail", orderDetail.url);
                        return <div className='Myorder_Buttons'>
                            <Button className='order-operation-btn1'
                                    onClick={() => this.OrderDetailOnRef.show(orderDetail, 6)}>详情</Button>
                            <Button
                                className={!orderDetail.url ? "noDownload-address-button" : "download-address-button"}
                                disabled={!orderDetail.url ? true : false}
                                onClick={() => this.downLoadFlie(orderDetail.url)}
                                type="primary"
                            >下载</Button>
                        </div>
                    }
                },
            ],
            7: [
                {
                    title: '订单号',
                    dataIndex: 'orderId',
                    key: 'orderId' + `-${this.state.type}-${this.state.page}`,
                    width: 300,
                    render: (_, data) => {
                        return <span title={data.ordercode}>{data.ordercode}</span>
                    }
                },
                {
                    title: '订单状态',
                    dataIndex: 'orderStatus',
                    key: 'orderStatus',
                    render: (_, data) => {
                        return <span title={data.orderstatus}>{data.orderstatus}</span>
                    }
                },
                {
                    title: '产品名称',
                    dataIndex: 'productSubclassName',
                    key: 'productSubclassName',
                    render: (_, data) => {
                        return <span title={data.algorithmname}>{data.algorithmname}</span>
                    }
                },
                {
                    title: '订单时间',
                    dataIndex: 'orderCreationTime',
                    key: 'orderCreationTime',
                    render: (_, data) => {
                        return <span>{transformtime(data.ordercreationtime, 'yyyy-mm-dd hh:mm:ss')}</span>
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (_, orderDetail) => {
                        return <div className='Myorder_Buttons'>
                            <Button className='order-operation-btn1'
                                    onClick={() => this.OrderDetailOnRef.show(orderDetail, 7)}>详情</Button>
                            <Button
                                className={orderDetail.iscluster === null || orderDetail.orderstatus !== "任务完成" ? "noDownload-address-button" : "download-address-button"}
                                disabled={orderDetail.iscluster === null || orderDetail.orderstatus !== "任务完成" ? true : false}
                                onClick={() => this.downLoadFlie(orderDetail.iscluster)}
                                type="primary"
                            >下载</Button>
                            <Dropdown overlay={
                                <div className='Myorder_DropdownOverlay'>
                                    <div className='Myorder_DropdownOverlay_Menu'
                                         onClick={() => this.reExameOrder(orderDetail)}>重新检验
                                    </div>
                                    <div className='Myorder_DropdownOverlay_Menu'
                                         onClick={() => this.reSubmitOrder(orderDetail)}>重新提交
                                    </div>
                                </div>
                            }>
                                <Button className='order-operation-btn1'
                                        type="primary"
                                >重检</Button>
                            </Dropdown>
                        </div>
                    }
                },
            ]
        }
        const {openIsDownOrderListFlag, nowReadyDLOrder} = this.state;
        return (
            <Template title="我的订单">
                <div className="usercenter-myorder-search-warp">
                    <div className="usercenter-myorder-search">
                        <div className="usercenter-myorder-search-input-warp">
                            <Input className="usercenter-myorder-search-input" placeholder="请输入订单号"
                                   ref='searchInput'></Input>
                        </div>
                        <Button className="usercenter-myorder-search-button" onClick={this.searchOrder}>
                            <img
                                className="usercenter-myorder-search-button-img"
                                src={require("./img/icon-serach.png")}
                            />
                            <p className="usercenter-myorder-search-button-p">查询</p>
                        </Button>
                    </div>
                    <div className="usercenter-myorder-timeselector">
                        <div className="usercenter-myorder-timeselector-wrap1">
                            <div className="usercenter-myorder-timeselector-starttime">
                                <p className="usercenter-myorder-timeselector-starttime-p">
                                    起始时间
                                </p>
                                <DatePicker onChange={(event) => {
                                    this.handleChange(event, 1)
                                }} defaultValue={moment()}
                                            value={this.state.startTime}
                                            className="usercenter-myorder-timeselector-starttime-picker"></DatePicker>
                            </div>
                            <div className="usercenter-myorder-timeselector-endtime">
                                <p className="usercenter-myorder-timeselector-endtime-p">
                                    终止时间
                                </p>
                                <DatePicker onChange={(event) => {
                                    this.handleChange(event, 2)
                                }} defaultValue={moment()}
                                            value={this.state.endTime}
                                            className="usercenter-myorder-timeselector-endtime-picker"></DatePicker>
                            </div>
                        </div>
                        <div className="usercenter-myorder-timeselector-wrap2">
                            <Radio.Group className="usercenter-myorder-timeselector-group" defaultValue={4}
                                         value={this.state.timeModeRadioValue} disabled={this.state.disabled}>
                                <Radio
                                    className="usercenter-myorder-timeselector-today"
                                    onClick={(e) => this.handleRadioclick(1)}
                                    value={1}
                                >
                                    <p className="usercenter-myorder-timeselector-today-p">
                                        今天
                                    </p>
                                </Radio>
                                <Radio
                                    className="usercenter-myorder-timeselector-week"
                                    onClick={(e) => this.handleRadioclick(2)}
                                    value={2}
                                >
                                    <p className="usercenter-myorder-timeselector-week-p">
                                        一周
                                    </p>
                                </Radio>
                                <Radio
                                    className="usercenter-myorder-timeselector-month"
                                    onClick={(e) => this.handleRadioclick(3)}
                                    value={3}
                                >
                                    <p className="usercenter-myorder-timeselector-month-p">
                                        一月内
                                    </p>
                                </Radio>
                                <Radio
                                    className="usercenter-myorder-timeselector-month"
                                    onClick={(e) => this.handleRadioclick(4)}
                                    value={4}
                                >
                                    <p className="usercenter-myorder-timeselector-month-p">
                                        全部
                                    </p>
                                </Radio>
                            </Radio.Group>
                        </div>
                    </div>
                </div>
                <Tabs
                    className="usercenter-myorder-tab"
                    activeKey={this.state.tabIndex}
                    onChange={this.onTabChange}
                >
                    <Tabs.TabPane tab={"下载订单"} key="1"></Tabs.TabPane>
                    <Tabs.TabPane tab={"上传订单"} key="2"></Tabs.TabPane>
                    <Tabs.TabPane tab={"生产订单"} key="3"></Tabs.TabPane>
                    <Tabs.TabPane tab={"未来订单"} key="4"></Tabs.TabPane>
                    <Tabs.TabPane tab={"仿真订单"} key="5"></Tabs.TabPane>
                    <Tabs.TabPane tab={"产品检验"} key="6"></Tabs.TabPane>
                    <Tabs.TabPane tab={"技术检验"} key="7"></Tabs.TabPane>
                </Tabs>
                <Table
                    className="usercenter-myorder-table"
                    key={`table-${this.state.type}`}
                    ref={(val) => {
                        this.refTable = val
                    }}
                    dataSource={this.state.data}
                    pagination={false}
                    expandedRowKeys={this.state.expandedRowKeys}
                    expandable={
                        this.state.tabIndex === '4' ? {
                                expandedRowRender,
                                expandIcon: ({expanded, onExpand, record}) =>
                                    expanded ? (
                                        <img className="order_table_expandIcon" src={expandIcon}
                                             onClick={e => onExpand(record, e)}/>
                                    ) : (
                                        <img className="order_table_expandIcon" src={expandIcon_1}
                                             onClick={e => onExpand(record, e)}/>
                                    )
                            } :
                            this.state.tabIndex === '1' ? {
                                    expandedRowRender: expandedRowRenderForDownloadOrder,
                                    expandIcon: ({expanded, onExpand, record}) =>
                                        expanded ? (
                                            <img className="order_table_expandIcon" src={expandIcon}
                                                 onClick={e => onExpand(record, e)}/>
                                        ) : (
                                            <img className="order_table_expandIcon" src={expandIcon_1}
                                                 onClick={e => onExpand(record, e)}/>
                                        )
                                }
                                : this.state.tabIndex === '3' ? {
                                    expandedRowRender: expandedRowRenderForProduceOrder,
                                    expandIcon: ({expanded, onExpand, record}) =>
                                        expanded ? (
                                            <img className="order_table_expandIcon" src={expandIcon}
                                                 onClick={e => onExpand(record, e)}/>
                                        ) : (
                                            <img className="order_table_expandIcon" src={expandIcon_1}
                                                 onClick={e => onExpand(record, e)}/>
                                        )
                                } : null}
                    columns={columns[this.state.type]}
                    expandIcon
                    onExpand={(flag, data) => this.showAndCloseOrderChildren(flag, data)}
                    onExpandedRowsChange={(expandedRows) => this.closeElseRows(expandedRows)}
                    loading={this.state.isLoading}
                ></Table>
                <Pagination
                    className="usercenter-myorder-pagination"
                    total={this.state.total}
                    current={this.state.page}
                    onChange={this.onPageChange}
                    showSizeChanger={false}
                ></Pagination>
                <OrderDetail ref={(ref) => (this.OrderDetailOnRef = ref)}
                             OrderDetailOnRefComponent={this.OrderDetailOnRefComponent}></OrderDetail>

                <Modal visible={openIsDownOrderListFlag} onOk={this.downloadMainOrder}
                       onCancel={() => this.setState({openIsDownOrderListFlag: false})}>
                    <div className='MyOrder_DLOrderModalContent'>
                        <div className='MyOrder_DLOrderModalText'>订单号：{nowReadyDLOrder.orderId}</div>
                        <div
                            className='MyOrder_DLOrderModalText'>该订单下子订单数为{nowReadyDLOrder.downLoadOrderFilesList.length}条，确定下载所有子订单吗？
                        </div>
                    </div>
                </Modal>
            </Template>
        );
    }

    downloadMainOrder = () => {
        const {nowReadyDLOrder} = this.state;
        this.openClient(nowReadyDLOrder.downLoadOrderFilesList);
        this.setState({openIsDownOrderListFlag: false})
    }

    downLoadFlie = (url) => {
        console.log("downLoadFlie", url);
        if (navigator.clipboard && window.isSecureContext) {
            // navigator clipboard 向剪贴板写文本
            message.success('订单下载url已复制')
            navigator.clipboard.writeText(url)
        } else {
            // 创建text area
            const textArea = document.createElement('textarea')
            textArea.value = url
            // 使text area不在viewport，同时设置不可见
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()
            message.success('订单下载url已复制')
            document.execCommand('copy')
            textArea.remove()
        }
    }

    returnLessName = (name) => {
        if (!name) return "";
        if (name.length > 25) {
            let returnName = name;
            returnName = name.slice(0, 22) + "...";
            return returnName;
        } else
            return name;
    }
    returnFileName = (name) => {
        const {typeList} = this.state;
        if (name.length > 35) {
            let returnName = name;
            for (let i = 0; i < typeList.length; i++) {
                let type = typeList[i];
                if (name.includes(type)) {
                    returnName = name.slice(0, 35) + "..." + type;
                    break;
                }
            }
            return returnName;
        } else
            return name;
    }

    returnFileSizeText = (size) => {
        if ((size / 1000) < 1000) {
            return (size / 1000).toFixed(2) + " KB";
        } else if ((size / 1024 / 1000) < 1000) {
            return (size / 1024 / 1000).toFixed(2) + " MB";
        } else if ((size / 1024 / 1024 / 1000) < 1000) {
            return (size / 1024 / 1024 / 1000).toFixed(2) + " GB";
        } else {
            return (size / 1024 / 1024 / 1024 / 1000).toFixed(2) + " TB";
        }
    }
    OrderDetailOnRefComponent = (ref) => {
        this.OrderDetailOnRef = ref;
    }
}

const mapState = state => ({
    user: state.userReducer.get('user').toJS(),
})

export default connect(mapState)(MyOrder)
